import { useAuth } from '@/components/auth/AuthProvider';

// Simplified hook that uses the unified auth state from context
export const useTeams = () => {
  const { teams, loading, error, refetchTeams } = useAuth();
  
  return {
    teams,
    loading,
    error,
    refetch: refetchTeams,
  };
};

export const useCurrentTeam = () => {
  const { currentTeamId, setCurrentTeamId } = useAuth();
  
  return {
    currentTeamId,
    setCurrentTeamId,
  };
};

export const useTeamRole = (teamId: string | undefined) => {
  const { getUserRole, canAccessContactInfo, canEdit, canAnalyze } = useAuth();
  
  if (!teamId) {
    return {
      role: null,
      loading: false,
      canAccessContactInfo: false,
      canEdit: false,
      canAnalyze: false,
    };
  }

  return {
    role: getUserRole(teamId),
    loading: false,
    canAccessContactInfo: canAccessContactInfo(teamId),
    canEdit: canEdit(teamId),
    canAnalyze: canAnalyze(teamId),
  };
};

export const useBusinessContactAccess = (businessId: string | undefined) => {
  // This would need to be enhanced to check business-specific access
  // For now, simplified to team-level access
  const { currentTeamId, canAccessContactInfo } = useAuth();
  
  return {
    canAccess: currentTeamId ? canAccessContactInfo(currentTeamId) : false,
    loading: false,
  };
};